import { createFileRoute } from '@tanstack/react-router'
import { ScriptsSection } from '@/features/vsl/scripts/ScriptsSection'

export const Route = createFileRoute('/_authenticated/vsl/scripts')({
  component: ScriptsSection,
})
